import React, { useState } from "react";
import PatientSearchingTable from "components/PatientSearchingTable";
import { deleteErrorResultById } from "services/errorResults";
import { uploadErrorFileToCoreplus } from "services/uploadFileToCoreplus";
import { STATUS } from "../../../constants";
import { downloadErrorResultFile } from "../services/errorResultService";
const { LOADING, DEFAULT, SUCCEED, FAILED } = STATUS;
const isDataFromPMS = process.env.REACT_APP_DATA_SOURCE === "pms-api";

const ClientUploadComponent = ({ file, onFinish, aiOcr }) => {
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [failureReason, setFailureReason] = useState(null);

  const onSelectPatient = (patient) => setSelectedPatient(patient);

  const [downloadStatus, setDownloadStatus] = useState({ status: DEFAULT });
  const handleDownloadErrorResult = async (e) => {
    setDownloadStatus({ status: LOADING });
    e.preventDefault();
    const fileName = file?.fileName;
    if (fileName) {
      try {
        const res = await downloadErrorResultFile(fileName, aiOcr);
        const link = document.createElement("a");
        link.href = "data:application/octet-stream;base64," + res.data;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setDownloadStatus({ status: SUCCEED });
      } catch (e) {
        setDownloadStatus({ status: FAILED, error: "Fail to download error result" });
      }
    } else {
      setDownloadStatus({ status: FAILED, error: "Error result id is not exist." });
    }
  };

  const handleDeleteResult = async () => {
    setFailureReason(null);
    setIsDeleting(true);

    const { error: deleteError } = await deleteErrorResultById({ id: file?.id, aiOcr });
    if (deleteError) {
      setFailureReason(deleteError.message);
      setIsDeleting(false);
      return;
    }

    onFinish && onFinish();
    setIsDeleting(false);
  };

  const uploadTheTestResult = async () => {
    setFailureReason(null);
    setIsUploading(true);

    const { error: uploadError } = await uploadErrorFileToCoreplus({
      clientId: selectedPatient?.patientId,
      fileName: file?.fileName, // this is for medical result
      fileId: file?.id,
      specialistId: null,
      fromReferralInbox: false,
      aiOcr,
    });
    if (uploadError) {
      setFailureReason(uploadError.message);
      setIsUploading(false);
      return;
    }

    onFinish && onFinish();
    setIsUploading(false);
  };

  return (
    <>
      <PatientSearchingTable selectedPatient={selectedPatient} onSelectPatient={onSelectPatient} />
      <div className="buttons">
        <button
          disabled={!selectedPatient || isUploading}
          className={`button is-primary is-small is-radiusless${isUploading ? " is-loading" : ""}`}
          onClick={uploadTheTestResult}
        >
          {isDataFromPMS ? "Upload to pms" : "Upload to coreplus"}
        </button>

        <button
          disabled={isUploading || isDeleting}
          className={`button is-small is-danger is-light is-radiusless${isDeleting ? " is-loading" : ""}`}
          onClick={handleDeleteResult}
        >
          Delete Result
        </button>

        <button
          className={`button is-small is-radiusless is-success is-light${
            downloadStatus.status === LOADING ? " is-loading" : ""
          }`}
          onClick={handleDownloadErrorResult}
        >
          Download Result
        </button>

        <p className="has-text-danger is-size-7">{failureReason}</p>
      </div>
    </>
  );
};

export default ClientUploadComponent;
